import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { watch } from 'vue';

import '@rednex/gateway_core/dayjs';
//### Function imports

//### Service imports
//--- Service imports

//### Model imports
//--- Model imports
import { SidePanelViewType } from '@rednex/gateway_core';
//### Component imports
import NavigationBar from '@/core/navigation-bar/navigation-bar.vue';
//@TODO: mobile view verbesserung
import Sidebar from '@/core/sidebar/sidebar.vue';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props, { expose: __expose }) {
  __expose();

//### Function imports
const store = useStore();
//--- Setup

//### Store/Reactive Data
const extendedSearchComponentVisible = computed(() => store.getters.extendedSearchComponentVisible);
const inList = computed(() => store.getters.inList);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isPhoneDevice = computed(() => store.getters.isPhoneDevice);
const isTabletDevice = computed(() => store.getters.isTabletDevice);
const menuExpanded = computed(() => store.getters.menuExpanded);
const sidepanel = computed(() => store.getters.sidepanel);
const themeMode = computed(() => store.getters.themeMode);
//--- Store/Reactive Data

//### Variables const let
let ctxExtendedSearch;
let ctxSidebar;
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
	refreshTheme();
	watch(sidepanel, () => {
		ctxSidebar = sidepanel;
	});
});
//--- Component Lifecycle

//### Functions
function refreshTheme() {
	themeMode.value === 'dark' ? require('@content/scss/rs-theme/rs-theme-dark.scss') : require('@content/scss/rs-theme/rs-theme.scss');
}
//--- Functions

const __returned__ = { store, extendedSearchComponentVisible, inList, isAuthenticated, isPhoneDevice, isTabletDevice, menuExpanded, sidepanel, themeMode, get ctxExtendedSearch() { return ctxExtendedSearch }, set ctxExtendedSearch(v) { ctxExtendedSearch = v }, get ctxSidebar() { return ctxSidebar }, set ctxSidebar(v) { ctxSidebar = v }, refreshTheme, get SidePanelViewType() { return SidePanelViewType }, NavigationBar, Sidebar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})